import { getDaysInCurrentMonth, getToday } from "./calendarUtils";

export const calculateTotalToday = (expenses) => {
  const today = new Date().toLocaleDateString();
  return expenses
    .filter((expense) => new Date(expense.date).toLocaleDateString() === today)
    .reduce((total, expense) => total + parseFloat(expense.amount), 0);
};

export const calculateTotalThisMonth = (expenses) => {
  //const currentMonth = new Date().getMonth();
  //const currentYear = new Date().getFullYear();
  return expenses
    /*.filter((expense) => {
      const expenseDate = new Date(expense.date);
      return (
        expenseDate.getMonth() === currentMonth &&
        expenseDate.getFullYear() === currentYear
      );
    })*/
    .reduce((total, expense) => total + parseFloat(expense.amount), 0);
};

export const calculateBudgetDiff = (expenses, budget) => {
  const budgetDiff =
    (budget / getDaysInCurrentMonth()) * getToday() -
    calculateTotalThisMonth(expenses);
  return budgetDiff;
};
export const overUnderBudget = (expenses, budget) => {
  function removeLeadingHyphen(str) { if (str.charAt(0) === '-') { return str.slice(1); } return str; }
  var spend = calculateBudgetDiff(expenses, budget);
  if (spend > 0) {
    spend = "$" + spend.toFixed(0) + " under budget";
    return <span className="text-green-800">{spend}</span>;
  }
  spend = "$" + removeLeadingHyphen(spend.toFixed(0) + " over budget");
  return <span className="text-red-700">{spend}</span>;
};

export const calculatePercentThruBudget = (expenses, budget) => {
  return (calculateTotalThisMonth(expenses) / budget).toFixed(2) * 100;
};

export const calculateTotalsByCategory = (expenses, setTotalsByCategory) => {
  const totals = expenses.reduce((acc, expense) => {
    acc[expense.category] = (acc[expense.category] || 0) + expense.amount;
    return acc;
  }, {});
  setTotalsByCategory(totals);
};
